// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".societyFilter[data-v-61ed354b] {\n  float: right;\n}", "",{"version":3,"sources":["webpack://./src/pages/Reports.vue","webpack://./Reports.vue"],"names":[],"mappings":"AACA;EACC,YAAA;ACAD","sourcesContent":["\r\n.societyFilter {\r\n\tfloat: right;\r\n}\r\n",".societyFilter {\n  float: right;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
